// The auto-replay when the ring was empty: an old bout plays back through the same player
// as a live one (opening, turn by turn with the thinking dots between, the ceremony), then
// the channel rolls on to the next bout.
import { $, setClock } from "./dom.ts";
import { player, takeBack } from "./live.ts";
import { ring } from "./tv.ts";
import { T } from "./timing.ts";
import { doneFromPage } from "./wire.ts";
import { wantStage } from "./show.ts";

/** a turn has typed and the other side is "thinking": a beat proportional to what was said */
export const thinkTime = (said: string) => {
  const words = said.split(/\s+/).length;
  return Math.min(
    T.REPLAY_THINK_MAX,
    Math.max(T.REPLAY_THINK_MIN, T.REPLAY_THINK_BASE + words * T.REPLAY_THINK_PER_WORD),
  );
};

export function initReplay(tv: TvHooks) {
  const bout = $("article.bout[data-replay]");
  if (!bout) return;
  const list = $("[data-transcript]", bout) as HTMLElement;
  const turns = [...(list.querySelectorAll("li.msg") as NodeListOf<HTMLElement>)].map(takeBack);
  bout.classList.add("playing"); // the turns are taken back: what the player appends is meant to be seen
  if (!turns.length) return;
  const done = doneFromPage(bout, turns.length);
  if (!done) {
    console.warn("replay without an ending");
    return;
  }
  setClock($("[data-turn]", bout), 0);
  let i = 0;
  let timer: ReturnType<typeof setTimeout> | null = null;
  const next = () => {
    const m = turns[i++];
    p.push(m);
    if (i >= turns.length) p.end(done); // the last turn is in (and typing): the seal follows it
  };
  const p = player(bout, tv, {
    cap: T.TYPE_CAP_REPLAY,
    keepState: true,
    hold: wantStage(), // the replay's opening plays first too
    onIdle: () => {
      timer = setTimeout(next, thinkTime(turns[i - 1].content));
    },
  });
  p.open();
  next();
  ring.onTeardown(() => {
    if (timer) clearTimeout(timer);
  });
}
